import React, { Component, PropTypes } from 'react';
import { formatNumber, DateFormatter } from '../../utils/date';
import Pixeltext from '../../components/svg/pixeltext';
import graphDots from './graph-dots.png';
import graphTextDots from './graph-text-dots.png';
import css from './evolution.scss';

export default class Evolution extends Component {
	static propTypes = {};
	constructor(props) {
		super(props);
	}

	render() {

		return (
			<section className='evolution'>
				<div className='evolution__top'>
					<div className='evolution__left span9 span14-mobile'>
						<h2 className='evolution__title'>Judging Evolution</h2>
						<h3 className='evolution__label'>Points:</h3>
					</div>
					<div className='case-single__meta-scorecard span5 pixel-pattern hide-mobile'>
						<div className='case-single__meta-scorecard__stats case-single__meta-scorecard__stats--evolution hide-mobile'>
							<h3 className='case-single__meta-scorecard__title'>FWA award stats:</h3>
						</div>
						<div className='case-single__meta-scorecard__points case-single__meta-scorecard__points--evolution' ref='pointsTooltipTablet'>
							<h3 className='case-single__meta-scorecard__title'>Points:</h3>
							{this.props.points && (
								<span className='case-single__meta-scorecard__number case-single__meta-scorecard__number--evolution'>{formatNumber(this.props.points)}</span>
							)}
						</div>

						<div className='case-single__meta-scorecard__days case-single__meta-scorecard__days--evolution'>
							<h3 className='case-single__meta-scorecard__title'>Days:</h3>
							<span className='case-single__meta-scorecard__number case-single__meta-scorecard__number--evolution'>{this.props.days}</span>
						</div>
					</div>
				</div>
				<section className='evolution-graph span14 pixel-pattern'>
					<div className='evolution-graph__left span2'>
						<div className='evolution-graph__marker'>
							{this.props.browser.window.width > 1200 && (
							<div>
								<Pixeltext text='100'/>
								<Pixeltext text='pts'/>
							</div>
							) || this.props.browser.window.width > 719 && (
							<Pixeltext text='100'/>
							) || (
							<span>100</span>
							)}
						</div>
						<div className='evolution-graph__marker fifty'>
							{this.props.browser.window.width > 1200 && (
							<div>
								<Pixeltext text='50'/>
								<Pixeltext text='pts'/>
							</div>
							) || this.props.browser.window.width > 719 && (
							<Pixeltext text='50'/>
							) || (
							<span>50</span>
							)}
						</div>
						<div className='evolution-graph__marker null'>
							{this.props.browser.window.width > 1200 && (
							<div>
								<Pixeltext text='00'/>
								<Pixeltext text='pts'/>
							</div>
							) || this.props.browser.window.width > 719 && (
							<Pixeltext text='00'/>
							) || (
							<span>00</span>
							)}
						</div>
					</div>
					{this.renderEvolutions(this.props.evolution, this.props.awardDate, this.props.fotdText, this.props.hasFOTD)}
				</section>
				<div className='evolution-graph__labels span14'>
					<span className='evolution-graph__labels__days hide-mobile'>days</span>
				</div>
			</section>
		);
	}

	renderEvolutions(evolutions, awardDate, awardTitle, hasFOTD) {
		let height = 714;
		let width = 1079;
		let plusser = 50;

		if (this.props.browser.window.width < 1440) {
			width = 875;
		}

		if (this.props.browser.window.width < 1200) {
			width = 731;
			height = 304;
			plusser = 40;
		}

		if (this.props.browser.window.width < 1000) {
			width = 570;
		}

		if (this.props.browser.window.width < 720) {
			width = 431;
			height = 152;
			plusser = 13;
		}

		if (this.props.browser.window.width < 568) {
			width = 239;
		}

		let path = 'M0,' + height + ' L0,';

		let xmultiplier = width / (evolutions.length - 1);

		evolutions.map((evolution, i) => {
			if (i == 0) {
				path += height - evolution.point * (height / 100) + plusser;
			} else if (i == evolutions.length - 1) {
				path += ' L' + width + ',' + (height - evolution.point * (height / 100) + plusser) + ' L' + width + ',' + height + ' Z';
			} else {
				path += ' L' + (xmultiplier * i) + ',' + (height - evolution.point * (height / 100) + plusser);
			}
		});

		return (
			<svg className='evolution-graph__grid span12'>
				<pattern id='graphDots' patternUnits='userSpaceOnUse' width={2} height={2}>
					<image width={graphDots.width} height={graphDots.height} xlinkHref={graphDots.src}></image>
				</pattern>
				<pattern id='graphTextDots' patternUnits='userSpaceOnUse' width={2} height={2}>
					<image width={graphTextDots.width} height={graphTextDots.height} xlinkHref={graphTextDots.src}></image>
				</pattern>
				<pattern id='lineDots' patternUnits='userSpaceOnUse' width={1} height={2}>
					<image width={graphTextDots.width} height={graphTextDots.height} xlinkHref={graphTextDots.src}></image>
				</pattern>
				<g>
					<path className='evolution-graph__filler' d={path}></path>
				</g>
				<g>
					{evolutions.map((evolution, i) => this.renderEvolution(evolution, i, evolutions.length, awardDate, awardTitle, hasFOTD))}
				</g>
			</svg>
		);

	}

	renderEvolution(evolution, i, length, awardDate, awardTitle, hasFOTD) {
		let uid = evolution.uid || ('evolution' + i);
		let height = 714;
		let xmultiplier = 1079 / (length - 1);
		let days = i.toString();
		let labelDay = i.toString();
		let plusser = 50;

		if (labelDay < 10) {
			labelDay = labelDay.toString();
			labelDay = '0' + labelDay;
		}

		if (this.props.browser.window.width < 1440) {
			xmultiplier = 875 / (length - 1);
		}

		if (this.props.browser.window.width < 1200) {
			xmultiplier = 731 / (length - 1);
			height = 304;
			plusser = 40;
		}

		if (this.props.browser.window.width < 1000) {
			xmultiplier = 570 / (length - 1);
		}

		if (this.props.browser.window.width < 720) {
			xmultiplier = 431 / (length - 1);
			height = 152;
			plusser = 13;
		}

		if (this.props.browser.window.width < 568) {
			xmultiplier = 239 / (length - 1);
		}

		if (i < 10) {
			days = '0' + days;
		}

		return (
			<g key={uid}>
				<pattern id='middleDot' patternUnits='userSpaceOnUse' width='8' height='8'>
					<rect width='2' height='2'fill='black' y='50%' x='50%'>
					</rect>
				</pattern>
				{i == length - 1 && !hasFOTD && (
				<g className='evolution-graph__points--wrap' x={xmultiplier * i - 6} y={height - evolution.point * (height / 100) - 6 + plusser} width='32' height='32' rx='4' ry='4'>
					<rect className='evolution-graph__hoverFill' x={xmultiplier * i - 16} y={height - evolution.point * (height / 100) - 16 + plusser} width='32' height='32'></rect>
					<rect className='evolution-graph__points' x={xmultiplier * i - 6} y={height - evolution.point * (height / 100) - 6 + plusser} width='12' height='12' rx='4' ry='4'></rect>
					<rect className='evolution-graph__points--middle' x={xmultiplier * i - 1} y={height - evolution.point * (height / 100) - 1 + plusser} width='2' height='2' rx='3' ry='3'></rect>
				</g>
				) || i == length - 1 && hasFOTD && (
				<g className='evolution-graph__points evolution-graph__points--wrap' x={xmultiplier * i - 6} y={height - evolution.point * (height / 100) - 6 + plusser} width='32' height='32' rx='4' ry='4'>
					<rect className='evolution-graph__hoverFill' x={xmultiplier * i - 16} y={height - evolution.point * (height / 100) - 16 + plusser} width='32' height='32'></rect>
					<rect className='evolution-graph__points evolution-graph__points--win' x={xmultiplier * i - 6} y={height - evolution.point * (height / 100) - 6 + plusser} width='12' height='12' rx='4' ry='4'></rect>
					<rect className='evolution-graph__points--middle' x={xmultiplier * i - 1} y={height - evolution.point * (height / 100) - 1 + plusser} width='2' height='2' rx='3' ry='3'></rect>
				</g>
				) || (
				<g className='evolution-graph__points--wrap' x={xmultiplier * i - 4} y={height - evolution.point * (height / 100) - 4 + plusser}>
					<rect className='evolution-graph__hoverFill' x={xmultiplier * i - 16} y={height - evolution.point * (height / 100) - 16 + plusser} width='32' height='32'></rect>
					<rect className='evolution-graph__points' x={xmultiplier * i - 4} y={height - evolution.point * (height / 100) - 4 + plusser} width='8' height='8' rx='3' ry='3'></rect>
					<rect className='evolution-graph__points--middle' x={xmultiplier * i - 1} y={height - evolution.point * (height / 100) - 1 + plusser} width='2' height='2' rx='3' ry='3'></rect>
				</g>
				)}

				<g className='evolution-graph__label'>
					{i == 0 && (
						<text className='evolution-graph__label__text hide-mobile' x={xmultiplier * i} y={height + 28}>{labelDay}</text>
					) || i == length - 1 && (
						<text className='evolution-graph__label__text--last hide-mobile' x={xmultiplier * i - 9} y={height + 28}>{labelDay}</text>
					) || (
						<g>
							<line className='evolution-graph__label__line' x1={xmultiplier * i - 1} y1={height} x2={xmultiplier * i - 1} y2={height - 15}></line>
							<line className='evolution-graph__label__line hide-tablet hide-mobile' x1={xmultiplier * i - 1} y1={0} x2={xmultiplier * i - 1} y2={15}></line>
							<text className='evolution-graph__label__text hide-mobile' x={xmultiplier * i - 9} y={height + 28}>{labelDay}</text>
						</g>
					)}
				</g>

				{i == length - 1 && !hasFOTD && this.props.browser.window.width < 1000 && (
				<text className='evolution-graph__current' x={xmultiplier * i - 60} y={height - evolution.point * (height / 100) - 27 + plusser} >current score</text>
				) || i == length - 1 && !hasFOTD && (
				<text className='evolution-graph__current' x={xmultiplier * i - 40} y={height - evolution.point * (height / 100) - 27 + plusser} >current score</text>
				) || null}

				{i == length - 1 && hasFOTD && this.props.browser.window.width < 1000 && (
					<text className='evolution-graph__current' x={xmultiplier * i - 60} y={height - evolution.point * (height / 100) - 27 + plusser} >{awardTitle}</text>
				) || i == length - 1 && hasFOTD && (
					<text className='evolution-graph__current' x={xmultiplier * i - 40} y={height - evolution.point * (height / 100) - 27 + plusser} >{awardTitle}</text>
				) || null}

				{i == length - 1 && hasFOTD && this.props.browser.window.width < 1000 && (
				<g className='evolution-graph__text-holder hide-mobile'>
					<text className='evolution-graph__text' x={xmultiplier * i - 90} y={height - evolution.point * (height / 100) - 80} >{evolution.point}</text>
					<text className='evolution-graph__text--small' x={xmultiplier * i - 30} y={height - evolution.point * (height / 100) - 80} >Pts</text>
					<text className='evolution-graph__text' x={xmultiplier * i - 90} y={height - evolution.point * (height / 100) - 20} >{days}</text>
					<text className='evolution-graph__text--small' x={xmultiplier * i - 30} y={height - evolution.point * (height / 100) - 20} >Days</text>
				</g>
				) || (
				<g className='evolution-graph__text-holder hide-mobile'>
					<text className='evolution-graph__text' x={xmultiplier * i - 40} y={height - evolution.point * (height / 100) - 80} >{evolution.point}</text>
					<text className='evolution-graph__text--small' x={xmultiplier * i + 30} y={height - evolution.point * (height / 100) - 80} >Pts</text>
					<text className='evolution-graph__text' x={xmultiplier * i - 40} y={height - evolution.point * (height / 100) - 20} >{days}</text>
					<text className='evolution-graph__text--small' x={xmultiplier * i + 30} y={height - evolution.point * (height / 100) - 20} >Days</text>
				</g>
				)}
			</g>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/evolution/evolution.js
 **/